import { Container, Card } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './Leadership.css';

export interface LeadershipProps {
  members: AboutContentDto['leadership'];
}

export function Leadership({ members }: LeadershipProps) {
  if (members.length === 0) {
    return null;
  }
  return (
    <section className="dma-leadership" aria-labelledby="dma-leadership-heading">
      <Container>
        <h2 id="dma-leadership-heading">ساختار مدیریتی و سهامداری</h2>
        <div className="dma-leadership__grid">
          {members.map((member) => (
            <Card key={member.name} className="dma-leadership__item">
              <h3 className="dma-leadership__name">{member.name}</h3>
              <p className="dma-leadership__role">{member.role}</p>
              {member.ownershipPercent !== null ? (
                <p className="dma-leadership__ownership">{member.ownershipPercent}٪ سهام</p>
              ) : null}
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
}
